import styled from "@emotion/styled";
import { ResponsiveTableCell } from "../../../../components/layout/responsive-table/responsive-table-cell.component";

export const ProductNameCellStyled = styled(ResponsiveTableCell)<{ active: boolean }>`
  width: 200px;
`;
